// custom-actions.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../src/lib/alg-auth';

@Injectable({
  providedIn: 'root'
})
export class RenameService {

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService) {
  }

  rename(node: any, nom: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${node.id}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService);
    // @ts-ignore
    headers = headers.append('Authorization', auth);
    let rename = {
      "properties": {
        "cm:name": nom,

      }
    }
    return this.http.put(endpointUrl, rename, {headers: headers});
  }
}
